module.exports = __webpack_public_path__ + "static/media/image (3).edaa1ee4.jpg";